import { render, staticRenderFns } from "./SustainableSpaces.vue?vue&type=template&id=b11fd1f8&"
import script from "./SustainableSpaces.vue?vue&type=script&lang=ts&"
export * from "./SustainableSpaces.vue?vue&type=script&lang=ts&"
import style0 from "./SustainableSpaces.vue?vue&type=style&index=0&id=b11fd1f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports